import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { applyInitialTheme } from './lib/store/app';
import './styles/global.css';
import { bootstrapQuizWebViewSession } from './features/quiz/learner/quizWebViewBootstrap';
import { bootstrapPlanH5Session } from './lib/auth/planH5Session';

// Keep await inside a function: iOS 14 WebViews cannot parse top-level await.
async function bootstrap() {
  await bootstrapPlanH5Session();
  await bootstrapQuizWebViewSession();
  applyInitialTheme();

  // App owns analytics and error-reporting initialization. Its module graph is
  // evaluated only after the injected token has been consumed and deleted.
  const { default: App } = await import('./App');
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
}

void bootstrap().catch(() => {
  const root = document.getElementById('root');
  if (!root) return;
  const message = document.createElement('p');
  message.textContent = '页面加载失败，请退出后重新进入。';
  message.setAttribute('role', 'alert');
  root.replaceChildren(message);
});
